import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage6(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage6',
    animations: [
      { x: vw(0.455), y: vh(-0.48), duration: 2 },
      { x: vw(0.127), y: vh(-0.595), duration: 2 },
      { x: vw(0.345), y: vh(-0.257), duration: 2 },
      { x: vw(-0.36), y: vh(-0.55), duration: 2 },
      { x: vw(-0.398), y: vh(-0.31), duration: 2 },
      { x: vw(-0.05), y: vh(-0.2), duration: 2 },
    ],
  });
}
